export const endsWithVowel = (noun?: string) => {
  if (noun === undefined || noun === null) {
    return '';
  }

  if (
    ['a', 'e', 'i', 'o', 'u', 'y', 'h'].includes(noun.charAt(noun.length - 1))
  ) {
    return true;
  }

  const charCode = noun.charCodeAt(noun.length - 1);
  let letters: string[];

  if (charCode >= 0xac00 && charCode <= 0xd7a3) {
    const initialConsonant = (charCode - 0xac00) / 28 / 21;

    const vowel = ((charCode - 0xac00) / 28) % 21;

    const finalConsonant = (charCode - 0xac00) % 28;

    letters = [
      String.fromCharCode(initialConsonant + 0x1100),

      String.fromCharCode(vowel + 0x1161),

      finalConsonant ? String.fromCharCode(finalConsonant + 0x11a7) : '',
    ];
  } else {
    letters = [noun];
  }
  if (letters.length === 2) {
    return true;
  }

  if (letters.length === 3) {
    if (letters[2] === '') {
      return true;
    }
    return false;
  }

  return false;
};
